export default "__VITE_ASSET__db6a0082__"